import { render } from "./ReadProgressBar.vue?vue&type=template&id=227e60fa&scoped=true"
import script from "./ReadProgressBar.vue?vue&type=script&lang=js"
export * from "./ReadProgressBar.vue?vue&type=script&lang=js"

import "./ReadProgressBar.vue?vue&type=style&index=0&id=227e60fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-227e60fa"

export default script